<div class="p-grid p-fluid">
  <div class="col-md-12 col-sm-12 col-xs-12">
    <h3>
      <i class="pi pi-exclamation-triangle"></i>

      You have unsaved changes. Leaving this page will discard them. Do you want to continue?
    </h3>
  </div>
  <div class="col-md-12 col-sm-12 col-xs-12 margin-top-15 text-align-right p-mb-2 p-button-auto-width">
    <p-button label="Stay" class="p-mr-1"  pTooltip="Cancel" tooltipPosition="bottom"
              (click)="cancel()" type="submit" ></p-button>
      <p-button label="Leave"  pTooltip="Save" tooltipPosition="bottom"
                (click)="processData()" type="submit" ></p-button>
  </div>
</div>
